import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import FiltersButton from '../../FilterButton';

const createPeriodDates = (startMonth, startDay, endMonth, endDay) => ({
	start: { month: startMonth, day: startDay },
	end: { month: endMonth, day: endDay }
});

const buttonsList = [
	{
		title: 'Весна',
		name: 'spring',
		period: createPeriodDates('3', '1', '5', '31')
	},
	{
		title: 'Лето',
		name: 'summer',
		period: createPeriodDates('6', '1', '8', '31')
	},
	{
		title: 'Осень',
		name: 'autumn',
		period: createPeriodDates('9', '1', '11', '30')
	},
	{
		title: 'Зима',
		name: 'winter',
		period: createPeriodDates('12', '1', '2', '28')
	}
];

const getISODate = (year, month, day) => new Date(year, month - 1, day);

const SeasonsButtonsBlock = ({ currentSeason, setPeriod, classNameSetter }) => {
	const onPeriodChange = ({ name, period }) => {
		const currentYear = new Date().getFullYear();
		const { start, end } = period;
		const newStartDate = getISODate(currentYear, start.month, start.day);
		const preparedPeriod = {
			startDate: newStartDate,
			endDate: getISODate(
				name === 'winter' ? currentYear + 1 : currentYear,
				end.month,
				end.day
			)
		};

		setPeriod(preparedPeriod, name);
	};

	const matchedSeason = useMemo(
		() => buttonsList.find(({ name }) => name === currentSeason),
		[currentSeason]
	);

	const dropDateAndSeason = () => setPeriod({}, '');

	const changeOrDropSeasonPeriod = (season) =>
		matchedSeason?.name === season.name
			? dropDateAndSeason()
			: onPeriodChange(season);

	return (
		<>
			{buttonsList.map((season) => (
				<FiltersButton
					key={season.title}
					className={classNameSetter(matchedSeason?.name === season.name)}
					title={season.title}
					onClick={() => changeOrDropSeasonPeriod(season)}
				/>
			))}
		</>
	);
};

SeasonsButtonsBlock.propTypes = {
	currentSeason: PropTypes.string,
	setPeriod: PropTypes.func,
	classNameSetter: PropTypes.func
};

export default SeasonsButtonsBlock;
